module.exports = __webpack_public_path__ + "img/collection.aafa6496.png";